/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.OutOfOfficeHoursRpc
 */
import * as References from './OutOfOfficeHoursRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.OutOfOfficeHoursRpc#fetchOutOfOfficeStatuses
 */
export const FETCH_OUT_OF_OFFICE_STATUSES_QUERY_FIELD_NAME =
  'com_hubspot_cv_assignments_rpc_OutOfOfficeHoursRpc_fetchOutOfOfficeStatuses';
export const FETCH_OUT_OF_OFFICE_STATUSES_QUERY: RegisteredQuery<
  'result',
  References.FetchOutOfOfficeStatusesRequestType,
  References.FetchOutOfOfficeStatusesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FETCH_OUT_OF_OFFICE_STATUSES_QUERY_FIELD_NAME,
  args: ['userIds'],
  fetcher(
    request: References.FetchOutOfOfficeStatusesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FetchOutOfOfficeStatusesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.fetchOutOfOfficeStatusesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
